import { gql, TypedDocumentNode } from "@apollo/client";

import {
  RetryFailedAutoSoapMutation,
  RetryFailedAutoSoapMutationVariables,
} from "./RetryFailedAutoSoap.generated";

export const RETRY_FAILED_AUTO_SOAP: TypedDocumentNode<
  RetryFailedAutoSoapMutation,
  RetryFailedAutoSoapMutationVariables
> = gql`
  mutation retryFailedAutoSoap(
    $noteUuid: String
    $jobType: String
    $templateUuid: String
    $skipTranscription: Boolean
  ) {
    retryFailedAutoSoap(
      noteUuid: $noteUuid
      jobType: $jobType
      templateUuid: $templateUuid
      skipTranscription: $skipTranscription
    ) {
      ok
    }
  }
`;
